import { DarkMode, DarkModePreference } from '@afterpaytouch/core'
import { parseCookies, setCookie } from 'nookies'

export const getInitialDarkMode = (): DarkMode => {
  if (typeof window === 'undefined') {
    return DarkMode.System
  }

  const darkModeAttr = document.documentElement.getAttribute('data-dark-mode')
  if (darkModeAttr === 'true') return DarkMode.Dark
  if (darkModeAttr === 'false') return DarkMode.Light
  return DarkMode.System
}

export const getDarkModePreference = (): DarkModePreference | undefined => {
  if (typeof window === 'undefined') return undefined
  const cookies = parseCookies()
  const cookieValue = cookies['apt-dark-mode'] as DarkModePreference
  if (['dark', 'light', 'system'].includes(cookieValue)) {
    return cookieValue
  }
  return 'system'
}

export const setDarkModePreference = (preference: DarkModePreference): void => {
  if (typeof window === 'undefined') return
  setCookie(null, 'apt-dark-mode', preference, {
    path: '/',
    sameSite: 'none',
    secure: true,
    maxAge: 365 * 24 * 60 * 60,
  })
}
